import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-adventure-quest-start-modal',
  templateUrl: './adventure-quest-start.component.html',
  styleUrls: ['./adventure-quest-start.component.scss'],
  standalone: true,
  imports: [AnimatedTimerComponent, ButtonComponent, SharedModule],
})
export class AdventureQuestStartModalComponent implements OnInit {
  adventureQuestStartModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private translateService = inject(TranslateService);
  private eventsRepo = inject(EventsRepository);

  componentDestroy: () => Observable<unknown>;

  lang: string;
  event: LimitedTimeEvent;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.event = this.eventsRepo.getEventById(this.adventureQuestStartModalData.properties.eventId);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.adventureQuestStartModalData.id, ModalType.Persisted, this.adventureQuestStartModalData)
    );
  }

  openMultiGameChallengesProgressive(): void {
    this.eventManager.openModal(
      new Modal(NonPersistedModalName.AdventureQuestModalComponent, ModalType.View, this.adventureQuestStartModalData)
    );
    this.closeModal();
  }
}
